export const CACHE_RESPONSE = 'zola/cache/CACHE_RESPONSE';
